import * as React from 'react';
//declare var google: any;

interface GoogleMapsProps {
    routes: Routes[];
}

interface GoogleMaps {
    googleRoute: GoogleRoute[];
    map: any;
}

interface GoogleRoute {
    name: string;
    start: google.maps.LatLng;
    waypts: google.maps.DirectionsWaypoint[];
    end: google.maps.LatLng;
}

interface Routes {
    orderManual: string;
    jobAddresses: JobAddress[];
}

interface JobAddress {
    placeId: string;
    address: string;
    lat: number;
    lng: number;
}

export default class GoogleMap extends React.Component<GoogleMapsProps, GoogleMaps> {
    constructor(props: GoogleMapsProps) {
        super(props);

        var office = new google.maps.LatLng(-37.817253, 145.299153);

        var routes = this.props.routes;
        var googleRoutes: GoogleRoute[] = [];

        for (var i = 0; i < routes.length; i++) {
            //get way points
            var waypts: google.maps.DirectionsWaypoint[] = [];
            for (var a = 0; a < routes[i].jobAddresses.length; a++) {
                var waypt = new google.maps.LatLng
                    ({
                        lat: routes[i].jobAddresses[a].lat,
                        lng: routes[i].jobAddresses[a].lng
                    });

                waypts.push({ location: waypt, stopover: true });
            }
            //add the google route with way points
            var googleRoute: GoogleRoute = {
                name: routes[i].orderManual,
                start: office,
                waypts: waypts,
                end: office
            }; 
            googleRoutes.push(googleRoute);
        }

        this.state = {
            map: '',
            googleRoute: googleRoutes
        }

    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    public componentDidMount() {
        const directionsService = new google.maps.DirectionsService();
        let map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
            center: { lat: -37.808854, lng: 145.049311 },
            zoom: 8
        });

        //get a list of route colours to use to separate the routes
        var routeColours = ["blue", "red", "green", "orange", "purple", "pink", "yellow"];

        //load the different routes
        var routes = this.state.googleRoute;

        for (var r = 0; r < routes.length; r++) {
            const directionsRenderer = new google.maps.DirectionsRenderer({
                polylineOptions: {
                    strokeColor: routeColours[r]
                },
                suppressMarkers: true       //have to create my own markers in order to use info window to display text
            });
            directionsRenderer.setMap(map);
            this.calculateAndDisplayRoute(directionsService, directionsRenderer, routes[r], map);
        }
        
    }

    calculateAndDisplayRoute = (directionsService: google.maps.DirectionsService, directionsRenderer: google.maps.DirectionsRenderer, route: GoogleRoute, map: google.maps.Map) => {
        directionsService.route(
            {
                origin: route.start,
                destination: route.end,
                waypoints: route.waypts,
                optimizeWaypoints: true,
                travelMode: google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
                if (status === "OK" && response) {
                    directionsRenderer.setDirections(response);
                    const route = response.routes[0];
                    const summaryPanel = document.getElementById(
                        "directions-panel"
                    ) as HTMLElement;
                    if (summaryPanel) {
                        summaryPanel.innerHTML += "";

                        // For each route, display summary information.
                        for (let i = 0; i < route.legs.length; i++) {
                            const routeSegment = i + 1;
                            summaryPanel.innerHTML +=
                                "<b>Route Segment: " + routeSegment + "</b><br>";
                            summaryPanel.innerHTML += route.legs[i].start_address + " to ";
                            summaryPanel.innerHTML += route.legs[i].end_address + "<br>";
                            summaryPanel.innerHTML += route.legs[i].distance!.text + "<br><br>";
                        }
                    }

                    this.createStartMarker(map);

                    var routes = this.props.routes;

                    for (var r = 0; r < routes.length; r++) {
                        var wayPoint = routes[r].jobAddresses;
                        for (var i = 0; i < wayPoint.length; i++) {
                            this.createMarker(map, wayPoint[i], routes[r].orderManual);
                        }
                    }

                } else {
                    window.alert("Directions request failed due to " + status);
                }
            }
        );
    }

    createStartMarker(map: google.maps.Map) {
        //create start point marker
        var branch = new google.maps.LatLng(-37.817253, 145.299153);

        var marker = new google.maps.Marker({ position: branch, map: map, title: "Bayswater North Branch" });
        var infoText = this.getMarkerText("34 Gatwick Road, Bayswater North", "Bayswater North Branch");
        var info = new google.maps.InfoWindow({ content: infoText });
        google.maps.event.addListener(marker, 'click', function () {
            info.open(map, marker);
        });

        google.maps.event.addListener(map, 'click', (function (info) {
            return function () {
                info.close();
            }
        })(info));

        return marker;
    }

    createMarker = (map: google.maps.Map, wayPoint: JobAddress, orderManual: string) => {
        var position = { lat: wayPoint.lat, lng: wayPoint.lng };
        var address = wayPoint.address;
        var name = orderManual;

        var markerText = this.getMarkerText(address, name);

        var infopopup = new google.maps.InfoWindow({ content: markerText });
        var marker = new google.maps.Marker({ position: position, map: map, title: name });

        google.maps.event.addListener(marker, 'click', function () {
            //infowindow.setContent(markerText);
            infopopup.open(map, marker);
        });

        google.maps.event.addListener(map, 'click', (function (infopopup) {
            return function () {
                infopopup.close();
            }
        })(infopopup));

        return marker;
    }

    getMarkerText = (address: string, name: string) => {
        return '<div>' +
            '<h3>' + address + '</h3>' +
            '<span>' + name + '</span>' +
            '</div>';
    }

    public render() {
        return (
            <div>
                <div className="map" id="map"></div>
                <div id="directions-panel"></div>
            </div>
        );
    }
}


